import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';


@Injectable()
export class GeneralService {

  constructor(
    private http: HttpClient,
  ) { }
  private basePath = ENPOINT.url;

  serviceLog(modulo): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set("Access-Control-Allow-Origin", "*") 
        .set("SameSite", 'None'),
      withCredentials: true,
      params: new HttpParams()
      .set('modulo', modulo)
    };
    return this.http.get(this.basePath + 'log/visitoModulo', options);
  }


}



// WEBPACK FOOTER //
// ./src/app/services/admin/general.service.ts